import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { HitType } from "src/types/Algolia";

export const useFilterApplied = (
  items: (
    | HitType
    | { count: number; isRefined: boolean; label: string; value: string }
  )[],
  refine: (value: string[]) => void
): {
  filterApplied: boolean;
  handleRefine: (value: string[]) => () => void;
  setFilterApplied: Dispatch<SetStateAction<boolean>>;
} => {
  const [filterApplied, setFilterApplied] = useState(false);
  const [changed, setChanged] = useState(false);
  const handleRefine = (value: string[]) => () => {
    refine(value);
    setChanged(true);
  };

  useEffect(() => {
    if (changed) {
      const someRefined = items.find((e) => e.isRefined);
      setFilterApplied(!!someRefined);
    }
  }, [items, changed]);

  return { filterApplied, handleRefine, setFilterApplied };
};
